module.exports = __webpack_public_path__ + "img/Unlock_Button.ae0b3c04.png";